module.exports = __webpack_public_path__ + "static/media/logo.aa001470.ico";